import { useEffect, useState } from 'react';
import { useParams, useLocation } from "react-router-dom";
import { fetchEvent } from '../../apis/eventsApi';
import { scheduleEvent } from '../../apis/sessionsApi';
import Attendees from '../../components/Attendees';
import Features from '../../enums/features';
import { useLoading } from "../../components/LoadingContext";
import SchedulePolicyModal from '../../components/schedulePolicyModal';
import { getIsHoursToCancelFeatureOn, getIsPenalizationFeatureOn } from '../../config';
import { openNotification } from '../../components/notifications';
import Messages from '../../utils/Messages';

const Event = () => {
  const { event_id } = useParams();
  const location = useLocation();

  // Parse query params
  const queryParams = new URLSearchParams(location.search);
  const is_unique = queryParams.get('is_unique') === 'true';
  const is_edited = queryParams.get('is_edited') === 'true';
  const start_date = queryParams.get('start_date');
  const end_date = queryParams.get('end_date');

  const [event, setEvent] = useState(null);
  const [showScheduleModal, setShowScheduleModal] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  
  const [error, setError] = useState(null);
  const { setLoading } = useLoading();
  const [isCheckAttendanceEnabled, setIsCheckAttendanceEnabled] = useState(false);
  const isHoursToCancelFeatureOn = getIsHoursToCancelFeatureOn();
  const isPenalizationFeatureOn = getIsPenalizationFeatureOn();
  
  useEffect(() => {
    function checkFeatures() {
        setLoading(true);
        try{
          const features = JSON.parse(localStorage.getItem('user_features') || '{}');
        setIsCheckAttendanceEnabled(features[Features.CHECK_ATTENDANCE] || false);
        } catch (err) {
          setError('Error loading features');
        } finally {
          setLoading(false);
        }
    }
    checkFeatures();
  }, []);

  useEffect(() => {
    const loadEvent = async () => {
      try {
        setLoading(true);
        const eventData = await fetchEvent(
          event_id,
          is_unique,
          is_edited,
          start_date,
          end_date
        );
        setEvent(eventData);
      } catch (err) {
        setError('Error loading event');
      } finally {
        setLoading(false);
      }
    };
    loadEvent();
  }, [is_unique, is_edited, event_id, start_date, end_date]);

  /* TODO: move this to a common component (see nextSessions.js)*/
  const handleSchedule = (event) => {
    if (isPenalizationFeatureOn || isHoursToCancelFeatureOn) {
      setSelectedEvent(event);
      setShowScheduleModal(true);
    } else {
      handleScheduleEvent(event);
    }
  };
  const handleScheduleEvent = async (event) => {
    const result = await scheduleEvent(event);
    setShowScheduleModal(false);

    const userLanguage = navigator.language || navigator.userLanguage; // Detect browser language
    if(result.success) {
      setShowScheduleModal(false);
      openNotification(
        "success",
        "",
        Messages.getMessage("SUCCESS_SCHEDULE", userLanguage)
      );
    } else {
      const backendMsg = result.error.response?.data?.error;
      const messageCode = result.error.response?.data?.responseCode || "UNKNOWN_ERROR";
      openNotification('error',
        'Error al agendar',
        backendMsg || Messages.getMessage(messageCode, userLanguage),
      );
    }
  }
  /*end*/
  if (error) return <p>Error: {error}</p>;
  if (!event) return null;

  return (
    <div className='mobile-block centered-container m-auto text-center'>
      {event.image && (
        <div style={{width: "42.19vh", height: "75vh"}}>
          <img
            src={event.image?.startsWith('http') || event.image?.startsWith('/') ? event.image : `/img/${event.image}`}
            alt=""
            style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                display: "block"
            }}
          />
        </div>
      )}
      {event.description && (
        <div className="mt-4 mb-4">
          <p>{event.description}</p>
        </div>
      )}
      <button type="button" class="btn themed-btn my-3 d-block" onClick={() => handleSchedule(event)}>Agendar</button>
      <SchedulePolicyModal
        show={showScheduleModal}
        event={selectedEvent}
        onClose={() => setShowScheduleModal(false)}
        onConfirm={handleScheduleEvent}
      />
      { isCheckAttendanceEnabled  && (
        <Attendees event={event}/>
      )}
    </div>
  );
};

export default Event;
